var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMayaeatsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "maya-eats-logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 168,
    height: 22.364,
    viewBox: "0 0 168 22.364",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M5.12,26.549h3.7v-14.5l7.389,5.843,7.409-5.843v14.5h3.747V4.3L16.245,13.022,5.12,4.3Z",
    transform: "translate(-5.12 -4.293)",
    fill: "#28abe3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M301.95,26.549h4.572l6.541-13.887,6.668,13.887h4.541L313.111,4.3Z",
    transform: "translate(-275.562 -4.293)",
    fill: "#28abe3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M733.2,26.549h4.572l6.541-13.887,6.668,13.887h4.541L744.361,4.3Z",
    transform: "translate(-668.473 -4.293)",
    fill: "#28abe3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M1244.83,26.549h4.572l6.541-13.887,6.668,13.887h4.541L1255.992,4.3Z",
    transform: "translate(-1134.619 -4.293)",
    fill: "#4c535c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M527.428,26.549h3.651V16.282L540.67,4.3h-5.018l-6.129,8.235L522.95,4.3h-4.54l9.049,11.982Z",
    transform: "translate(-472.778 -4.293)",
    fill: "#28abe3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(91.231 0.007)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 14.765,
    height: 3.694,
    fill: "#4c535c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 14.765,
    height: 3.694,
    transform: "translate(0 18.555)",
    fill: "#4c535c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 13.147,
    height: 3.694,
    transform: "translate(0 9.278)",
    fill: "#4c535c"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M1504.9,4.3H1486.39V7.994h7.41V26.549h3.694V7.994h7.41Z",
    transform: "translate(-1354.704 -4.293)",
    fill: "#4c535c"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M1744.339,9.523l3.027-2.392s-2.075-3.07-7.028-2.9-7.3,3.631-7.177,6.838,2.953,5.3,6.636,5.747,4.668,2.794,2.985,4.89-5.208.826-6.383-.445l-2.953,2.445s2.858,4,8.955,2.572,6-8.51,3.62-10.733-4.446-2.064-6.923-2.636-2.794-4.065.254-4.763S1744.021,8.835,1744.339,9.523Z",
    transform: "translate(-1579.532 -4.224)",
    fill: "#4c535c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMayaeatsLogo);
export default __webpack_public_path__ + "static/media/mayaeats_logo.207e841b10e3663d014abb1e34739a0b.svg";
export { ForwardRef as ReactComponent };